<template>
    <div class="login-box">
        <div class="login-logo">
            <a :href="meta.homeUrl"><b>{{ meta.appName }}</b></a>
        </div>
        <div class="card">
            <div class="card-body login-card-body">
                <p class="login-box-msg">開始登入你的帳號</p>
                <div class="input-group mb-3">
                    <input id="email" type="email" class="form-control" placeholder="信箱" v-model="form.email"
                           @keyup.enter="send" autofocus>
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-envelope"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required('email') ? 'show' : 'hide']"
                         role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫信箱</div>
                    </div>
                </div>
                <div class="input-group mb-3">
                    <input id="password" type="password" class="form-control" placeholder="密碼" v-model="form.password"
                           @keyup.enter="send">
                    <div class="input-group-append">
                        <div class="input-group-text">
                            <span class="fas fa-lock"></span>
                        </div>
                    </div>
                    <div class="tooltip fade bottom-right" :class="[required('password') ? 'show' : 'hide']"
                         v-show="required('password')" role="tooltip">
                        <div class="tooltip-arrow"></div>
                        <div class="tooltip-inner">請填寫密碼</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-8"></div>
                    <div class="col-4">
                        <button type="button" class="btn btn-success btn-block" @click="send">登入</button>
                    </div>
                </div>
                <div class="login-bottom-div">
                    <a :href="meta.registerUrl" class="text-center">註冊帳號</a>
                    <span>或</span>
                    <a :href="meta.resetUrl">忘記密碼</a>
                    <div id="loginCount" class="mt-2 text-muted small">
                        共登入
                        <span id="loginNum">{{ meta.loginCount }}</span>
                        次
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const $ = window.$;

export default {
    name: 'LoginApp',
    props: {
        initialData: {
            type: Object,
            required: true
        }
    },
    data() {
        const data = this.initialData ? JSON.parse(JSON.stringify(this.initialData)) : {};
        if(!data.form)
            data.form = {};
        if(!data.meta)
            data.meta = {};
        if(typeof data.isSend === 'undefined')
            data.isSend = false;
        return data;
    },
    methods: {
        send() {
            this.isSend = true;
            let $scrollTag = $('body'), $focusTag = null;
            if(!this.form.email)
                $focusTag = $('#email');
            else if(!this.form.password)
                $focusTag = $('#password');

            if($focusTag) {
                $scrollTag.animate({
                    scrollTop: $focusTag.offset().top
                }, 200, function() {
                    $focusTag.focus();
                });
                return;
            }

            const $loader = $('.login-card-body').loadingIndicator().data('loadingIndicator');
            $loader.show();

            $.ajax({
                method: 'POST',
                url: this.baseUrl + '/user/login',
                data: this.form
            }).done(function(data) {
                if(data.error === 0) {
                    $.toast({
                        heading: '登入成功',
                        text: data.datetime,
                        position: 'top-center',
                        loader: false,
                        icon: 'success'
                    });

                    location.href = data.url;
                } else {
                    $.toast({
                        heading: '發生錯誤',
                        text: data.message,
                        position: 'top-center',
                        loader: false,
                        icon: 'error'
                    });
                }
            }).fail(function(jqXHR) {
                let heading = '連線異常', message = '請檢查網路是否正常';
                if(jqXHR.status == 422) {
                    heading = '登入失敗';
                    message = '帳號或密碼錯誤';
                } else if(jqXHR.status == 423) {
                    heading = '登入失敗';
                    message = '嘗試登入次數過多，請稍後再試！';
                }
                $.toast({
                    heading: heading,
                    text: message,
                    position: 'top-center',
                    loader: false,
                    icon: 'error'
                });
            }).always(function() {
                $loader.hide();
            });
        },
        required(key) {
            let isInvalid = false;
            if(!this.form[key])
                isInvalid = true;
            return this.isSend && isInvalid;
        },
        confirmPassword() {
            let isInvalid = false;
            if(this.form.password != this.form.password_confirmation)
                isInvalid = true;
            return this.isSend && isInvalid;
        },
        min(key, length) {
            let isInvalid = false;
            if(!this.form[key] || this.form[key].length < length)
                isInvalid = true;
            return this.isSend && isInvalid;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/LoginApp.vue